import { apiPost, apiGet } from './config';

export default class AuthorizationApi {
    static async Authorize(credentials) {
        return apiPost('user_token', {
            auth: credentials,
        });
    }

    static async GetCurrentUser() {
        return apiGet('users/current');
    }
}
